import React from 'react'
import injectSheet from 'react-jss'
import { Presentation } from 'pobble-components/dist/presentation'

export const SlidesDeck = injectSheet({
  container: {
    display: 'flex',
    width: '200px',
    height: '112px',
    position: 'relative',
    '& *': {
      pointerEvents: 'none',
      userSelect: 'none',
      overflowY: 'hidden'
    }
  },
  slide: {
    boxShadow: '0 4px 4px rgba(0, 0, 0, .25)',
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    border: '2px solid #fff',
    borderRadius: '8px',
    overflow: 'hidden',
    textAlign: 'left',
    '&:first-child': {
      zIndex: '98 !important',
      transform: 'translateX(40px) rotate(5deg) translateY(10px)'
    },
    '&:nth-child(3)': {
      transform: 'translateX(-40px) rotate(-5deg) translateY(10px)'
    },
    '&:nth-child(4)': {
      transform: 'translateX(-80px) rotate(-10deg) translateY(20px)',
      display: 'none',
      '@media (min-width: 768px)': {
        display: 'block'
      }
    },
    '&:nth-child(5)': {
      transform: 'translateX(80px) rotate(10deg) translateY(20px)',
      display: 'none',
      '@media (min-width: 768px)': {
        display: 'block'
      }
    },
    '&:nth-child(6)': {
      transform: 'translateX(-120px) rotate(-15deg) translateY(30px)',
      display: 'none',
      '@media (min-width: 768px)': {
        display: 'block'
      }
    },
    '&:nth-child(7)': {
      transform: 'translateX(120px) rotate(15deg) translateY(30px)',
      display: 'none',
      '@media (min-width: 768px)': {
        display: 'block'
      }
    }
  }
})(({ classes, presentation }) => {
  return (
    <div className={classes.container}>
      <Presentation preview slideWidth={200} multiSlides data={presentation}>
        {({ slides }) => {
          return slides.slice(2, 10).map((slide, i) => {
            return (
              <div
                className={classes.slide}
                style={{ zIndex: 100 - i }}
                key={i}>
                <div className={classes.slideHolder}>{slide}</div>
              </div>
            )
          })
        }}
      </Presentation>
    </div>
  )
})
